<ng-container *ngIf="loaderScreen.state$ | async as state">
  <div class="loader-screen-backdrop" *ngIf="state.visible">
    <div class="loader-screen-content">
      <div class="loader-screen-spinner" aria-hidden="true"></div>
      <p class="loader-screen-text">{{ state.message }}</p>
    </div>
  </div>
</ng-container>
